<template>
    <div component="Contracts">
        <v-data-table
            ref="table"
            :footer-props="{ 'items-per-page-options': [10, 30, 50, 100] }"
            :headers="headers"
            :items="allActors"
            :items-per-page="50"
            :page.sync="page"
            :search="search"
            class="table"
            fixed-header
            loading-text="Loading... Please wait"
        >
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) in items" :key="index" :row="index" @click="openActor(item.id)">
                        <td>
                            {{ item.cislo_hlasu }}
                        </td>

                        <td>
                            {{ item.meno_priezvisko }}
                        </td>

                        <td>
                            {{ item.email }}
                            <br v-if="item.email2" />
                            {{ item.email2 }}
                        </td>

                        <td>
                            {{ item.telefon }}
                            <br v-if="item.telefon2" />
                            {{ item.telefon2 }}
                        </td>

                        <td>
                            {{ item.lang }}
                        </td>

                        <td>
                            <span
                                v-if="item.status === 0"
                                class="material-icons-outlined status-orange"
                                title="inactive"
                                >cancel</span
                            >
                            <span v-if="item.status === 1" class="material-icons-outlined status-green" title="active"
                                >check_circle</span
                            >
                            <span v-if="item.status === 2" class="material-icons-outlined status-red" title="deleted"
                                >delete</span
                            >
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Contracts',

    props: {
        filter: {
            default: {},
        },
    },

    data() {
        return {
            search: '',
            page: 1,
            projectStatus: null,
            projectStatusItems: ['CLOSED', 'APPROVED', 'SENT', 'IN PROGRESS'],
            headers: [
                { text: 'Voice number', value: 'cislo_hlasu' },
                { text: 'Actor', value: 'meno_priezvisko' },
                { text: 'Email', value: 'email' },
                { text: 'Phone', value: 'telefon' },
                { text: 'Lang', value: 'lang' },
                { text: 'Status', value: 'status' },
            ],
        };
    },

    methods: {
        openActor(id) {
            this.$router.push({ path: `/actors/detail/${id}` }).catch(() => {});
        },
    },

    computed: {
        ...mapGetters(['getAllActors']),

        allActors: function () {
            const normalizeText = (text) =>
                text
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
                    .toLowerCase();

            return this.getAllActors.filter((item) => {
                // Ak nie sú nastavené žiadne filtre, vráť všetky položky
                if (!this.filter.actor && !this.filter.status && !this.filter.search) {
                    return true;
                }

                let match = true;

                const status = item['status'].toString().toLowerCase();
                const actor = item['id'].toString().toLowerCase();

                if (this.filter.actor) {
                    match = match && actor === this.filter.actor.toString().toLowerCase();
                }

                if (this.filter.status) {
                    match = match && status.includes(this.filter.status.toString().toLowerCase());
                }

                if (this.filter.search) {
                    // Rozdelenie search textu na jednotlivé slová podľa medzier
                    const searchParts = normalizeText(this.filter.search).split(' ');

                    // Normalizujeme všetky relevantné vlastnosti položky
                    const name = item['meno_priezvisko'] ? normalizeText(item['meno_priezvisko'].toString()) : '';
                    const cisloHlasu = item['cislo_hlasu'] ? normalizeText(item['cislo_hlasu'].toString()) : '';
                    const email = item['email'] ? normalizeText(item['email'].toString()) : '';
                    const telefon = item['telefon'] ? normalizeText(item['telefon'].toString()) : '';
                    const lang = item['lang'] ? normalizeText(item['lang'].toString()) : '';

                    // Pre každý hľadaný text skontrolujeme, či je obsiahnutý v niektorej z vlastností
                    match =
                        match &&
                        searchParts.every(
                            (part) =>
                                name.includes(part) ||
                                cisloHlasu.includes(part) ||
                                email.includes(part) ||
                                telefon.includes(part) ||
                                lang.includes(part)
                        );
                }

                return match;
            });
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Contracts'] {
    display: flex;
    flex-direction: column;
    height: 0;
    flex-grow: 1;

    .table {
        display: flex;
        flex-direction: column;
        height: 0;
        flex-grow: 1;

        table {
            overflow: hidden !important;
        }

        tr {
            transition: 0.3s;
            position: relative;
            cursor: pointer;
        }

        .selected {
            td {
                background: fade(@base, 10%);

                &.id {
                    border-radius: 30px 0 0 30px;
                }

                &.action {
                    border-radius: 0 30px 30px 0;
                }
            }
        }

        .id {
            width: 65px;
            border-radius: 30px 0 0 30px !important;
        }

        .date {
            width: 180px;
        }

        .action {
            width: 30px;
            padding-left: 0;
            padding-right: 10px;
            border-radius: 0 30px 30px 0 !important;
        }

        .status-green {
            color: @color_green;
        }

        .status-orange {
            color: @color_orange;
        }

        .status-red {
            color: @color_magenta;
        }
    }

    .warning {
        .flex-row;
        justify-content: flex-end;
        position: absolute;
        right: 4px;
        top: 4px;
        height: 40px;
        z-index: 6;
        transition: 0.3s;
        transform: translateX(110%);
        padding: 0 5px 0 20px;
        border-radius: 30px;
        background-color: @primary !important;

        &.show {
            transform: translateX(0);
        }

        .label {
            font-weight: 700;
            color: white;
            margin-right: 10px;
        }

        button {
            margin-left: 3px;
        }
    }
}
</style>
